import { app } from '../../app.module'
app
  // 投稿タグ管理モーダル
  .directive('editPostTagModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $mdDialog) => {
        // モーダルを閉じる処理
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
